import React, {
  useEffect, useState, useRef, Fragment,
} from 'react';
import PropTypes from 'prop-types';

import { withTheme } from 'styled-components';
import { Row, Col } from '../../base/Grid';
import Typography from '../../base/Typography';

// styles
import {
  SwiperCarouselContainerRow, SwiperCarouselSwiperSlide, SwiperCarouselSwiperPagination, SwiperCarouselSwiperNavigation,
} from './styles';
import './carousel.scss';

export const CarouselModule = ({
  'data-app-name': appName,
  'data-dynamic-config-base-url': dynamicConfigBaseUrl,
  'data-static-config': staticConfig,
}) => {
  const [swiperLoaded, setSwiperLoaded] = useState(false);
  const swiperCarouselConfig = useRef();
  const [retrievedSwiperCarouselConfig, setRetrievedSwiperCarouselConfig] = useState(false); // triggers render to show banner

  useEffect(() => {
    /*
      Because we don't want swiper to bloat the bundle and these charts don't need to be ready on page load,
      we will render the script on mount and load the charts once ready.
    */
    const script = document.createElement('script');

    script.src = 'https://unpkg.com/swiper/swiper-bundle.min.js';
    script.async = true;

    document.body.appendChild(script);
    script.onload = () => {
      setSwiperLoaded(true);
    };

    const link = document.createElement('link');

    link.href = 'https://unpkg.com/swiper/swiper-bundle.min.css';
    link.rel = 'stylesheet';

    document.body.appendChild(link);
  }, []);

  useEffect(() => {
    // init videos for YouTube API
    // TODO: build out YT players array to utilize YT API

    // Initiate Swiper (node slider/carousel library)
    if (swiperLoaded) {
      // eslint-disable-next-line no-undef
      const thisSwiperCarousel = new Swiper('.swiper-container', {
        slidesPerView: 1,
        centeredSlides: true,
        grabCursor: true,
        autoplay: {
          delay: 5000,
        },
        speed: 400,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets',
        },
        on: {
          slideChange() {
            // pause prev video on slideChange
            const thisYTPlayer = this.slides[this.previousIndex].querySelectorAll('iframe')[0];
            thisYTPlayer && thisYTPlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            // players[thisSwiperCarousel.previousIndex].pauseVideo();

            // TODO: tap into YT API for more control
            // TODO: pause slider on YT video play
          },
        },
      });
    }
  }, [retrievedSwiperCarouselConfig, swiperLoaded]);

  useEffect(() => {
    // used by storybook
    if (staticConfig && swiperLoaded) {
      swiperCarouselConfig.current = staticConfig.swiperCarousel;
      console.log('swiperCarouselConfig.current', swiperCarouselConfig.current);
      setRetrievedSwiperCarouselConfig(true);
    }
    // TODO: dynamicConfig here
  }, [swiperLoaded]);

  return (
    (retrievedSwiperCarouselConfig && (
      <Fragment>
        {/* assuming this component will live within a <section> element */}
        <Typography component='h2' className='nmx-assistive-text'>Carousel HTML5 Heading: this should probably be put in the Page Container, just after the section element</Typography>
        <SwiperCarouselContainerRow className='swiper-container'>
          <Col className='nmx-section-thisSwiperCarousel-items swiper-wrapper'>
            {swiperCarouselConfig.current.map((swiperCarouselItem, index) => (
              <SwiperCarouselSwiperSlide className='swiper-slide' key={`${swiperCarouselItem}${index}`}>
                <Row align='center'>
                  <Col xsmall={10} large={8} className='nmx-align-center'>
                    <Typography variant='h2'>{swiperCarouselItem.data.heading}</Typography>
                    <Typography variant='p' align='left'>{swiperCarouselItem.data.text}</Typography>
                    <div className="video-container" data-video-id={swiperCarouselItem.data.videoId}>
                      <iframe width="600" height="320" src={`https://www.youtube.com/embed/${swiperCarouselItem.data.videoId}?enablejsapi=1`} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;enablejsapi;" allowFullScreen=""></iframe>
                    </div>
                  </Col>
                </Row>
              </SwiperCarouselSwiperSlide>
            ))}
          </Col>
          <SwiperCarouselSwiperNavigation className="swiper-button-prev" />
          <SwiperCarouselSwiperNavigation className="swiper-button-next" />
          <SwiperCarouselSwiperPagination className="swiper-pagination" />
        </SwiperCarouselContainerRow>
      </Fragment>
    ))
  );
};

CarouselModule.propTypes = {
  'data-static-config': PropTypes.object,
  'data-app-name': PropTypes.string,
  'data-dynamic-config-base-url': PropTypes.string,
};

export default withTheme(CarouselModule);
